/**
 * Resultado da execução da Tabela IBPT. Mesmos ids do catálogo db_motor_fiscal.ibpt_resultado_execucao.
 */
export enum IbptResultadoExecucaoEnum {
    EmAndamento = 1,
    Sucesso = 2,
    SemAlteracao = 3,
    Falha = 4,
    Cancelada = 5,
}
